  function callAPI(productId, tmpId) {
    var shopDomain = window.Shopify.shop
    const apiUrl = `https://options.shopapps.site/v2/${shopDomain}/generate_option/${productId}?tmp=${tmpId}`;
    // Use fetch to call the API
    fetch(apiUrl)
      .then(response => response.json())
      .then(data => {
        // Handle the API response data here
        // console.log(data);
        // Do whatever you need to do with the API response
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }


function observeDOM() {
  var observer = new MutationObserver(function(mutationsList) {
    for (var mutation of mutationsList) {
      if (mutation.type === 'childList') {

      const editButtons = document.querySelectorAll('.bold_cart_edit_button');
              // Add click event listeners to the buttons
      editButtons.forEach(button => {
        button.addEventListener('click', function() {
    
          console.log("BOLD EDIT CLICK")
          // Get the dynamic product ID and tmp ID from the data attributes
           const mainParentDiv = this.closest('.cart-item');
          const productId = mainParentDiv.getAttribute('data-prodid');
          const tmpId = BOLD.common.cacheParams.options;
    
          // Call the API with the dynamic IDs
          callAPI(productId, tmpId);
    });
  });
        observer.disconnect();
        break;
      }
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
document.addEventListener('DOMContentLoaded', function() {
  observeDOM();
});